import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  summaryCard: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderRadius: 12,
    padding: theme.spacing(4),
    backdropFilter: "blur(8px)",
     border: `1px solid ${theme.palette.text.impactText}`,
    position: "sticky",
    top: 96,
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "rgba(255, 255, 255, 0.1)",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
    },
  },

  summaryTitle: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.2em",
    color: "#06e89f",
    marginBottom: theme.spacing(4),
    textTransform: "uppercase",
    textAlign: "left",
  },

  productRow: {
    display: "flex",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },

  productImage: {
    width: 80,
    height: 80,
    borderRadius: 8,
    objectFit: "cover",
    filter: "grayscale(100%) contrast(125%)",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    transition: "filter 0.3s ease",
    "$summaryCard:hover &": {
      filter: "grayscale(0%) contrast(100%)",
    },
  },

  productLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.15em",
    color: theme.palette.text.paymentBack,
    textTransform: "uppercase",
    marginBottom: 4,
  },

  productName: {
    fontSize: "1.125rem",
    fontWeight: 700,
    color: theme.palette.text.billingtitle,
    lineHeight: 1.2,
    marginBottom: 4,
  },

  productRegion: {
    fontSize: "0.875rem",
    color: "#06e89f",
    fontWeight: 500,
  },

  divider: {
    height: 1,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    marginBottom: theme.spacing(3),
  },

  paymentSection: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
  },

  calcRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  calcLabel: {
    fontSize: "0.875rem",

    color: theme.palette.text.cardBadges,
    fontWeight: 500,
  },

  calcValue: {
    fontSize: "0.875rem",
    color: theme.palette.text.billingtitle,
    fontWeight: 600,
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: theme.spacing(3),
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    marginTop: theme.spacing(1),
  },

  totalLabel: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.billingtitle,
  },

  totalValue: {
    fontSize: "1.875rem",
    fontWeight: 800,
    color: "#06e89f",
    letterSpacing: "-0.02em",
  },

  impactAlert: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: "rgba(6, 232, 159, 0.05)",
    border: "1px solid rgba(6, 232, 159, 0.1)",
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "flex-start",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(6, 232, 159, 0.08)",
      borderColor: "rgba(6, 232, 159, 0.2)",
    },
  },

  impactIcon: {
    color: "#06e89f",
    fontSize: 20,
    flexShrink: 0,
    marginTop: 2,
  },

  impactText: {
    fontSize: 12,
    color: theme.palette.text.paymentDisabled,
    lineHeight: 1.5,
    textAlign: "left",
  },

  impactBold: {
    color: theme.palette.text.billingtitle,
    fontWeight: 700,
  },
}));

export { useStyles };
